import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { resetPasswordStart } from "../../store/actions/UserAction";
import { translate, t } from "react-multi-lang";
import { useParams } from "react-router-dom";
import "./ResetPassword.css"

const Reset = (props) => {

    const dispatch = useDispatch();
    const { token } = useParams();

    const [inputData, setInputData] = useState({
        password: "",
        password_confirmation: ""
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);

    // toggle password visibility
    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    // toggle confirm password visibility
    const toggleConfPassword = () => {
        setShowConfPassword(!showConfPassword);
    };

    // handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;

        setInputData((prev) => ({
            ...prev,
            [name]: value,
            reset_token: token
        }));
    };

    // submit handler
    const handleForgotPasswordSubmit = (event) => {
        event.preventDefault();

        const { password, password_confirmation } = inputData;

        if (password !== password_confirmation) {
            alert("Passwords do not match");
            return;
        }

        dispatch(resetPasswordStart(inputData));
    };

    return (
        <div className="signin-wrapper">
            <div className="signin-card">

                {/* LEFT SIDE */}
                <div className="signin-left">
                    <div className="logo-wrapper">
                        <a href="/">
                            <img
                                src="https://admin.rebeltv.me/rebel-homepage-assets/logo.png"
                                alt="logo"
                                className="signin-logo d-inline"
                            />
                        </a>
                    </div>

                    <h2 className="signin-title">RESET PASSWORD</h2>

                    <p className="signin-subtitle">
                        Enter your new password to reset your account.
                    </p>

                    <form onSubmit={handleForgotPasswordSubmit} method="post">
                        <div className="auth-form-group password-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder={t("new_password_placeholder")}
                                className="password-input"
                                required
                                autoComplete="off"
                                value={inputData.password}
                                name="password"
                                onChange={handleChange}
                            />
                            <span className="eye-icon" onClick={togglePassword}>
                                <i
                                    className={
                                        showPassword
                                            ? "fa fa-eye-slash"
                                            : "fa fa-eye"
                                    }
                                ></i></span>
                        </div>
                        <div className="auth-form-group password-group">
                            <input
                                placeholder={t("confirm_password")}
                                type={showConfPassword ? "text" : "password"}
                                required
                                className="password-input"
                                autoComplete="off"
                                name="password_confirmation"
                                value={inputData.password_confirmation}
                                onChange={handleChange}
                            />
                            <span className="eye-icon" onClick={toggleConfPassword}>
                                <i
                                    className={
                                        showConfPassword
                                            ? "fa fa-eye-slash"
                                            : "fa fa-eye"
                                    }
                                ></i></span>
                        </div>

                        <button
                            className="signin-btn"
                            type="submit"
                            disabled={props.inputData.buttonDisable}>
                            {props.inputData.loadingButtonContent !=
                                null
                                ? props.inputData.loadingButtonContent
                                : t("reset_password")}
                        </button>

                        {/* LOGIN LINK */}
                        <p className="signup-text">
                            Already have an account?
                            <a href="/signin"> Sign in</a>
                        </p>
                    </form>
                </div>

            </div>
        </div>
    );
}

const mapStateToPros = (state) => ({
    inputData: state.users,
});

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(translate(Reset));